import { roles } from "../config/config";

export const administrationPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
];

export const administrationClientPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
];
